import axios from 'axios';
import store from './store'
const req_url = store.state.req_url
const req_url2 = store.state.req_url2
const req_url3 = store.state.req_url3
import Cookies from 'js-cookie'
import md5 from 'md5'
// api_type 默认为1,1PHP接口，2JAVA接口


window.navigator.webdriver == true

export default async (type = 'get', url = '', data = {}, cb, api_type = 1) => {
	let api_url = api_type == 1 ? req_url : (api_type == 3 ? req_url3 : req_url2)
	if (url == '/alive/list') api_url = 'https://vcbeat-vbdata-api.vbdata.cn'
	let res

	if (type == 'get') {
		await axios.get(api_url + url).then(response => { res = response })
			.catch(error => {
				cb(error)
			})
	} else {
		if (url == '/user/apply') {
			await axios.post(api_url + url, data, { headers: { 'Content-Type': 'multipart/form-data', dataType: 'JSON' } }).then(response => {
				res = response
			}).catch(error => {
				cb(error)
			})
		} else {
			let timestamp
			if (api_type == 3) {
				let crc32 = function (r) { for (var a, o = [], c = 0; c < 256; c++) { a = c; for (var f = 0; f < 8; f++)a = 1 & a ? 3988292384 ^ a >>> 1 : a >>> 1; o[c] = a } for (var n = -1, t = 0; t < r.length; t++)n = n >>> 8 ^ o[255 & (n ^ r.charCodeAt(t))]; return (-1 ^ n) >>> 0 };
				let timestamp_org = Math.trunc(new Date().getTime() / 1000);
				let timestamp_crc = String(crc32(String(timestamp_org))).substring(0, 3)
				timestamp = Number(timestamp_org + timestamp_crc)
			} else {
				timestamp = new Date().getTime()
			}

			let params = {
				...data, ...{
					uUid: store.state.uUid,
					uUserId: store.state.uUserId
				}
			}
			let sign = JSON.stringify(params) + timestamp
			let config = {
				headers: {
					'content-Type': 'application/json; charset=UTF-8',
					'timestamp': timestamp,
					'sign': md5(sign)
				}
			}
			if (!window.navigator.webdriver) {
				await axios.post(api_url + url, JSON.stringify(params), config).then(response => {
					res = response
				}).catch(error => {
					cb(error)
				})
			}
		}
	}
	if (res.data.code == 1003 || res.data.code == 1001) {
		store.commit('updateUser', '')
		store.commit('updateUserKey', '')
		store.commit('updateFilter', '')
		store.commit('topicEntityCount', '')
		store.commit('topicTagCount', '')
		Cookies.remove('user_key_'+store.state.cookie_type, { domain: store.state.domain_path, path: '/'})
		window.localStorage.removeItem('show_scientific')

		window.location.href = store.state.index2_path
		return await res.data
	}
	return await res.data
}
